/**
 * Contratos zod del endpoint Remitos (input del ERP).
 */

import { z } from 'zod';
import { DESTINOS_REMITO, ESTADOS_REMITO_PLATAFORMA } from '@/domain/types';

export const DestinoRemitoSchema = z.enum(DESTINOS_REMITO);
export const EstadoRemitoPlataformaSchema = z.enum(ESTADOS_REMITO_PLATAFORMA);

export const RemitoItemSchema = z.object({
  gtin: z.string().regex(/^\d{14}$/),
  lote: z.string().min(1),
  cantidad: z.number().int().positive(),
  /** Si el ERP ya asignó series específicas (v9), las trae. */
  seriesIds: z.array(z.string()).optional(),
});

export const RemitoSchema = z.object({
  numero: z.string().min(1),
  /** Sigla del comprobante (TRS/RT/RD/REC) — opcional. */
  codigoComprobante: z.string().nullable().optional(),
  origenUbicacionId: z.string().min(1),
  destinoTipo: DestinoRemitoSchema,
  destinoUbicacionId: z.string().nullable().optional(),
  clienteId: z.string().nullable().optional(),
  domicilioEntregaId: z.string().nullable().optional(),
  fecha: z.string().datetime(),
  items: z.array(RemitoItemSchema).min(1),
  estadoEnPlataforma: EstadoRemitoPlataformaSchema,
});

export const GetRemitosResponse = z.array(RemitoSchema);

export type RemitoItem = z.infer<typeof RemitoItemSchema>;
export type Remito = z.infer<typeof RemitoSchema>;
